import OrderExportField from "../enum/Fields";

const FieldNameMap = {
    [OrderExportField.SHOP_NAME]: "店铺名称",

    [OrderExportField.ORIGINAL_ID]: "订单号",

    [OrderExportField.ORDER_STATUS]: "订单状态",

    [OrderExportField.BUYER_USERNAME]: "购买人昵称",

    [OrderExportField.CONSIGNEE_NAME]: "收件人姓名",

    [OrderExportField.PROVINCE]: "省",

    [OrderExportField.CITY]: "市",

    [OrderExportField.DISTRICT]: "区",

    [OrderExportField.STREET]: "地址",

    [OrderExportField.DETAILED_ADDRESS]: "完整地址",

    [OrderExportField.MOBILE]: "手机",

    [OrderExportField.TELEPHONE]: "电话",

    [OrderExportField.ZIP_CODE]: "邮编",

    [OrderExportField.LOGISTICS_COMPANY]: "快递公司",

    [OrderExportField.WAYBILL_NO]: "运单号",

    [OrderExportField.BUYER_REMARKS]: "买家留言",

    [OrderExportField.SELLER_REMARKS]: "卖家备注",

    [OrderExportField.ORDER_TIME]: "下单时间",

    [OrderExportField.PAYMENT_TIME]: "支付时间",

    [OrderExportField.SHIPPING_TIME]: "发货时间",

    [OrderExportField.END_TIME]: "完成时间",

    [OrderExportField.WEIGHT]: "重量(kg)",

    [OrderExportField.AMOUNTS]: "金额",

    [OrderExportField.DISCOUNTS]: "优惠",

    [OrderExportField.SHIPPING_COST]: "运费",

    [OrderExportField.PAYMENTS]: "实付",

    [OrderExportField.COD_AMOUNTS]: "代收货款金额",

    [OrderExportField.FLAG]: "旗帜",

    [OrderExportField.ORDER_MARK]: "订单标记",

    [OrderExportField.PRODUCT_ORIGINAL_ID]: "商品ID",

    [OrderExportField.PRODUCT_TITLE]: "商品标题/简称",

    [OrderExportField.PRODUCT_RAW_TITLE]: "商品标题",

    [OrderExportField.PRODUCT_SIMPLE_TITLE]: "商品简称",

    [OrderExportField.EXTERNAL_ID]: "商品编码",

    [OrderExportField.SKU_ORIGINAL_ID]: "SkuID",

    [OrderExportField.SKU_PROPERTIES]: "销售属性",

    [OrderExportField.PRODUCT_QUANTITY]: "数量",

    [OrderExportField.PRODUCT_PRICE]: "单价",

    [OrderExportField.ORDER_ITEM_COST]: "成本价",

    [OrderExportField.PRODUCT_WEIGHT]: "商品重量",

    [OrderExportField.PRODUCT_REFUNDING]: "商品退款状态",

    [OrderExportField.PRODUCT_STOCK_NO]: "货位",

    [OrderExportField.SEQUENCE_NO]: "流水号",

    [OrderExportField.SHIPPER_NAME]: "发货人",

    [OrderExportField.SUPPLIER_NAME]: "供货商",

    [OrderExportField.RETAILER_NAME]: "代理商",

    [OrderExportField.SUPPLIER_REMARKS]: "代发备注",

    [OrderExportField.AFFILIATE_MARKETER]: "带货达人",

    [OrderExportField.WAYBILL_PRINT_TIME]: "打印时间",

    [OrderExportField.SELLER_RECEIPTS]: "实收",
};

export default FieldNameMap;
